import type { Family, FamilyMember } from "@/hooks/useOptimizedFamily";
import type { FamilyGoal } from "@/services/familyService";

export const DEV_PREVIEW_FAMILY_ID = "dev-preview-family";

export const DEV_PREVIEW_FAMILY: Family = {
  id: DEV_PREVIEW_FAMILY_ID,
  primary_user_id: "dev-preview-user",
  name: "Sharma Family (sample preview)",
  is_archived: false,
  created_at: "2024-06-01T00:00:00.000Z",
  updated_at: "2024-06-01T00:00:00.000Z",
};

export const DEV_PREVIEW_MEMBERS: FamilyMember[] = [
  {
    id: "dev-member-1",
    family_id: DEV_PREVIEW_FAMILY.id,
    user_id: "dev-preview-user",
    full_name: "You (preview)",
    relationship: "Self",
    pan_number: "PREVIEW01",
    role: "ADMIN",
    date_of_birth: null,
    is_active: true,
    created_at: "2024-06-01T00:00:00.000Z",
    updated_at: "2024-06-01T00:00:00.000Z",
  },
  {
    id: "dev-member-2",
    family_id: DEV_PREVIEW_FAMILY.id,
    user_id: null,
    full_name: "Partner (preview)",
    relationship: "Spouse",
    pan_number: "PREVIEW02",
    role: "SPOUSE",
    date_of_birth: null,
    is_active: true,
    created_at: "2024-06-01T00:00:00.000Z",
    updated_at: "2024-06-01T00:00:00.000Z",
  },
];

export const DEV_PREVIEW_GOALS: FamilyGoal[] = [
  {
    id: "dev-goal-1",
    family_id: DEV_PREVIEW_FAMILY.id,
    goal_name: "Home down payment",
    target_amount: 2500000,
    current_amount: 850000,
    target_date: "2027-12-31",
    category: "Housing",
    description: "Sample goal for layout preview",
    currency: "INR",
    owner_member_id: DEV_PREVIEW_MEMBERS[0].id,
    goal_type: "family",
    priority: "high",
    monthly_contribution_amount: 25000,
    created_at: "2024-06-01T00:00:00.000Z",
    updated_at: "2024-06-01T00:00:00.000Z",
  },
];

export const DEV_PREVIEW_USER = {
  id: "dev-preview-user",
  email: "preview@example.com",
};

/** Dev-only: skip auth and use sample data when ?preview=1 is present. */
export function isFamilyHubDevPreviewActive(search: string): boolean {
  if (!import.meta.env.DEV) return false;
  return new URLSearchParams(search).get("preview") === "1";
}

export function isDevPreviewFamilyId(familyId: string | null | undefined): boolean {
  return familyId === DEV_PREVIEW_FAMILY_ID;
}

export function shouldQueryFamilyApi(familyId: string | null | undefined): boolean {
  return Boolean(familyId) && !isDevPreviewFamilyId(familyId);
}

export function getFamilyHubDevPreviewBundle() {
  return {
    family: DEV_PREVIEW_FAMILY,
    familyMembers: DEV_PREVIEW_MEMBERS,
    familyGoals: DEV_PREVIEW_GOALS,
    user: DEV_PREVIEW_USER,
  };
}
